import { render, staticRenderFns } from "./changeFlow.vue?vue&type=template&id=1507eddc&"
import script from "./changeFlow.vue?vue&type=script&lang=js&"
export * from "./changeFlow.vue?vue&type=script&lang=js&"
import style0 from "./changeFlow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports